module.exports = __webpack_public_path__ + "static/img/QLD-13.fd2a95b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-13.jpg
// module id = d342
// module chunks = 0